import { render, staticRenderFns } from "./Proceedings.vue?vue&type=template&id=252f64c4&scoped=true"
import script from "./Proceedings.vue?vue&type=script&lang=js"
export * from "./Proceedings.vue?vue&type=script&lang=js"
import style0 from "./Proceedings.vue?vue&type=style&index=0&id=252f64c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f64c4",
  null
  
)

export default component.exports